import { RM01_01 } from "./RM01_01";

export const RM01 = {
  columns: 12,
  rows: 2,
  visual: {
    id: 1,
    type: "advancedTable",
    colorTheme: "colorTheme1",
    title: "Coverage Summary",
    binding: {
      data: {
        columns: [
          {
            name: "Code",
            columnName: "AgentCode",
            width: "150px",
            align: "left",
            sortable: true,
          },
          {
            name: "Name",
            columnName: "EmployeeName",
            width: "220px",
            align: "left",
            sortable: true,
          },
          {
            name: "Call Rate",
            columnName: "CallRate",
            width: "150px",
            align: "center",
            sortable: true,
            percent: true,
          },
          {
            name: "Call Reach",
            columnName: "CallReach",
            width: "150px",
            align: "center",
            sortable: true,
            percent: true,
          },
          {
            name: "Call Frequency",
            columnName: "CallFrequency",
            width: "170px",
            align: "center",
            sortable: true,
            percent: true,
          },
          {
            name: "Average Calls",
            columnName: "AvgCallsPerDay",
            width: "170px",
            align: "center",
            sortable: true,
          },
          {
            name: "Regular Calls",
            columnName: "RegularCalls",
            width: "170px",
            align: "center",
            sortable: true,
          },
          {
            name: "Advanced Calls",
            columnName: "AdvancedCalls",
            width: "170px",
            align: "center",
            sortable: true,
          },
          {
            name: "Recovered Calls",
            columnName: "RecoveredCalls",
            width: "170px",
            align: "center",
            sortable: true,
          },
          {
            name: "Missed Calls",
            columnName: "MissedCalls",
            width: "170px",
            align: "center",
            sortable: true,
          },
          {
            name: "Incidental Calls",
            columnName: "IncidentalCalls",
            width: "170px",
            align: "center",
            sortable: true,
          },
        ],
        title: "EmployeeName",
        endpoint: "RM01",
        parameters: [
          { key: "CycleCode", value: "CP1" },
          { key: "CycleYear", value: "2026" },
          { key: "RegionCode", value: "" },
        ],
      },
      context: {
        point: {
          onClick: RM01_01,
        },
      },
    },
  },
};
